import { useEffect, useState, useRef } from 'react';

export function useOnlineStatus(initialStatus: boolean = navigator.onLine) {
  const [isOnline, setIsOnline] = useState<boolean>(initialStatus);
  // Optional: last change time
  const lastChangeRef = useRef<number>(Date.now());

  useEffect(() => {
    const updateOnlineStatus = (e?: Event) => {
      // navigator.onLine может не отражать реальный доступ к интернету в некоторых случаях
      // Мы всё равно используем его как первичную индикацию
      const online = navigator.onLine;
      if (online !== isOnline) {
        setIsOnline(online);
        lastChangeRef.current = Date.now();
      } else if (typeof e?.type === 'string') {
        // для некоторых браузеров можно force-update
        setIsOnline(online);
      }
    };

    // События браузера
    window.addEventListener('online', updateOnlineStatus);
    window.addEventListener('offline', updateOnlineStatus);

    // Опционально: периодический валидатор через тестовый запрос
    // (раскомментируйте и адаптируйте под ваш бэкенд)
    // const interval = setInterval(async () => {
    //   try {
    //     const resp = await fetch('/ping', { method: 'HEAD', cache: 'no-store' });
    //     if (resp.ok && !isOnline) setIsOnline(true);
    //   } catch {
    //     if (isOnline) setIsOnline(false);
    //   }
    // }, 30000);

    return () => {
      window.removeEventListener('online', updateOnlineStatus);
      window.removeEventListener('offline', updateOnlineStatus);
      // clearInterval(interval);
    };
  }, [isOnline]);

  return { isOnline, lastChangeAt: lastChangeRef.current };
}